import { React, useEffect, useState } from "react";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import { useHistory, useLocation } from "react-router-dom";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { LoaderScreen } from "../../../components/LoaderScreen";
import Swal from "sweetalert2";
import request from "../../../../Helpers/API";
import { FormatMoney } from "../../../../Helpers/FormatNumber";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { CargarConvenioModal } from "../Modal/CargarConvenioModal";
import { DescargarConvenioModal } from "../Modal/DescargarConvenioModal";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import FiltroConveniosRealizados from "../Components/FiltroConveniosRealizados";
import { useBox } from "../../ReporteCobranza/Helper/useBox";
import { GetKey } from "../../ReporteCobranza/Actions/GetContainer";

export const ListadoConveniosRealizadosScreen = () => {
  const history = useHistory();
  const { state } = useLocation();
  const [convenios, setConvenios] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [modalDescarga, setModalDescarga] = useState(false);

  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth() + 1;

  const fechaInicio = new Date(`${currentYear}-${currentMonth}-01`).toISOString().split('T')[0]
  const fechaFin = today.toISOString().split('T')[0]

  const initialStateboxfiltros = () => {
    return {
      fechaInicio: fechaInicio,
      fechaFin: fechaFin,
      responsable: "0",
      objecion: "999",
      pv: {
        adr: [],
        sucursal: [],
        vendedor: [],
      },
    };
  };

  const [boxstate, setBoxState] = useBox(initialStateboxfiltros);

  const [folio, setFolio] = useState("");
  const [titulo, setTitulo] = useState("BITACORA DE CONVENIOS REALIZADOS")
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  const handleOpenModal = (folio) => {
    setOpenModal(true);
    setFolio(folio);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const abrirModalDescarga = (folio) => {
    setModalDescarga(true);
    setFolio(folio);
  };

  const cerrarModalDescarga = () => {
    setModalDescarga(false);
  };

  useEffect(() => {
    setLoader({ ...loader, mostrar: true });
    onExecute(fechaInicio, fechaFin, 0);
    setLoader({ ...loader, mostrar: false });
  }, []);

  const onExecute = (fechaInicio, fechaFin, responsable) => {
    var sucursales = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
    var adr = GetKey(boxstate.pv.adr, ["idadr"]);
    if (sucursales === undefined || sucursales === null || sucursales === "") {
      sucursales = "0";
    }
    if (adr === undefined || adr === null || adr === "") {
      adr = "0";
    }

    // Convertimos el string a partes numéricas para evitar problemas de timezone
    const [anioI, mesI, diaI] = fechaInicio.split("-").map(Number);
    const [anioF, mesF, diaF] = fechaFin.split("-").map(Number);

    // Creamos las fechas usando Date(year, monthIndex, day)
    const fechaI = new Date(anioI, mesI - 1, diaI);
    const fechaF = new Date(anioF, mesF - 1, diaF);

    const meses = [
      "ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO",
      "JULIO", "AGOSTO", "SEPTIEMBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE"
    ];

    const mesInicio = meses[fechaI.getMonth()];
    const mesFin = meses[fechaF.getMonth()];
    const anioInicio = fechaI.getFullYear();
    const anioFin = fechaF.getFullYear();

    let rangoFechas = "";
    if (anioInicio === anioFin) {
      rangoFechas = `${mesInicio} - ${mesFin} - ${anioFin}`;
    } else {
      rangoFechas = `${mesInicio} ${anioInicio} - ${mesFin} ${anioFin}`;
    }

    const tituloP = `BITACORA DE CONVENIOS REALIZADOS - ${rangoFechas}`;

    setTitulo(tituloP);
    // console.log(adr, sucursales)
    return new Promise((resolve, reject) => {
      setLoader({ ...loader, mostrar: true });
      request
        .get(
          `DetalleClienteGestionarConvenios/ListadoParametros?fechainicio=${fechaInicio}&fechafin=${fechaFin}&responsable=${responsable}&objecion=${boxstate.objecion}&sucursal=${sucursales}&adr=${adr}`
        )
        .then((result) => {
          setLoader({ ...loader, mostrar: false });
          setConvenios(result);
          return;
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          reject(error);
          return;
        });
    });
  };
  // console.log(boxstate)

  const onGeneraExcel = (fechaInicio, fechaFin, responsable) => {
    var sucursales = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
    var adr = GetKey(boxstate.pv.adr, ["idadr"]);
    if (sucursales === undefined || sucursales === null || sucursales === "") {
      sucursales = "0";
    }
    if (adr === undefined || adr === null || adr === "") {
      adr = "0";
    }


    // Convertimos el string a partes numéricas para evitar problemas de timezone
    const [anioI, mesI, diaI] = fechaInicio.split("-").map(Number);
    const [anioF, mesF, diaF] = fechaFin.split("-").map(Number);

    // Creamos las fechas usando Date(year, monthIndex, day)
    const fechaI = new Date(anioI, mesI - 1, diaI);
    const fechaF = new Date(anioF, mesF - 1, diaF);

    const meses = [
      "ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO",
      "JULIO", "AGOSTO", "SEPTIEMBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE"
    ];

    const mesInicio = meses[fechaI.getMonth()];
    const mesFin = meses[fechaF.getMonth()];
    const anioInicio = fechaI.getFullYear();
    const anioFin = fechaF.getFullYear();

    let rangoFechas = "";
    if (anioInicio === anioFin) {
      rangoFechas = `${mesInicio} - ${mesFin} - ${anioFin}`;
    } else {
      rangoFechas = `${mesInicio} ${anioInicio} - ${mesFin} ${anioFin}`;
    }

    const tituloP = `BITACORA DE GESTION DE COBRANZA - ${rangoFechas}`;
    setLoader({ ...loader, mostrar: true });
    request
      .get(`DetalleClienteGestionarConvenios/ImprimirExcelReporte?fechainicio=${fechaInicio}&fechafin=${fechaFin}&responsable=${responsable}&objecion=${boxstate.objecion}&sucursal=${sucursales}&adr=${adr}&titulo=${tituloP}`)
      .then(({ documento, filename }) => {
        const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
        const downloadLink = document.createElement("a");
        const fileName = `${filename}.xlsx`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        setLoader({ ...loader, mostrar: false });
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("CREDITO Y COBRANZA", JSON.stringify(error), "error");
      });
  };
console.log(boxstate)
  const onGeneraPDF = (fechaInicio, fechaFin, responsable) => {
    var sucursales = GetKey(boxstate.pv.sucursal, ["idsucursal"]);
    var adr = GetKey(boxstate.pv.adr, ["idadr"]);
    if (sucursales === undefined || sucursales === null || sucursales === "") {
      sucursales = "0";
    }
    if (adr === undefined || adr === null || adr === "") {
      adr = "0";
    }


    // Convertimos el string a partes numéricas para evitar problemas de timezone
    const [anioI, mesI, diaI] = fechaInicio.split("-").map(Number);
    const [anioF, mesF, diaF] = fechaFin.split("-").map(Number);

    // Creamos las fechas usando Date(year, monthIndex, day)
    const fechaI = new Date(anioI, mesI - 1, diaI);
    const fechaF = new Date(anioF, mesF - 1, diaF);

    const meses = [
      "ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO",
      "JULIO", "AGOSTO", "SEPTIEMBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE"
    ];

    const mesInicio = meses[fechaI.getMonth()];
    const mesFin = meses[fechaF.getMonth()];
    const anioInicio = fechaI.getFullYear();
    const anioFin = fechaF.getFullYear();

    let rangoFechas = "";
    if (anioInicio === anioFin) {
      rangoFechas = `${mesInicio} - ${mesFin} - ${anioFin}`;
    } else {
      rangoFechas = `${mesInicio} ${anioInicio} - ${mesFin} ${anioFin}`;
    }

    const tituloP = `BITACORA DE GESTION DE COBRANZA - ${rangoFechas}`;

    setLoader({ ...loader, mostrar: true });
    request
      .get(`DetalleClienteGestionarConvenios/ImprimirPDFReporte?fechainicio=${fechaInicio}&fechafin=${fechaFin}&responsable=${responsable}&objecion=${boxstate.objecion}&sucursal=${sucursales}&adr=${adr}&titulo=${tituloP}`)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        const linkSource = `data:application/pdf;base64, ${result.documento}`;
        const downloadLink = document.createElement("a");
        const fileName = `${result.nombredocumento}.${result.extension}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("Clientes", JSON.stringify(error), "error");
      });
  };


  return (
    <PlantillaScreen
      titulo={titulo}
      className={"convenio-pago-main-screen"}
      className_main={1}
    >
      <div className="listado-convenios-actions">
        <div
          className="listado-convenios-actions-regresar"
          onClick={() => history.goBack()}
        >
          <ArrowBackIcon /> Regresar
        </div>
        <div className="listado-convenios-actions-filtro">
          <FiltroConveniosRealizados
            onExecute={onExecute}
            boxState={boxstate}
            onBoxChange={setBoxState}
            mostrarObjecion={true}
          />
        </div>
        <div className="buttons">
          <button className="excel"
            onClick={() => onGeneraExcel(boxstate.fechaInicio, boxstate.fechaFin, boxstate.responsable)}
          >
            <i className=" icon-file-excel" /> Excel
          </button>
          <button className="PDF"
            onClick={() =>
              onGeneraPDF(boxstate.fechaInicio, boxstate.fechaFin, boxstate.responsable)
            }
            style={{ backgroundColor: '#940404' }}>
            PDF
          </button>
        </div>
      </div>
      <div className="listado-convenios-cliente">
        <LoaderScreen loader={loader} />
        <div className="listado-convenios-cliente-header">
          <div className="listado-convenios-cliente-header-title">
            <FormatListNumberedIcon /> Listado de Convenios Realizados
          </div>
          <div className="contador-convenios-encontrados">
            Convenios Encontrados: {convenios.length}
          </div>
        </div>
        <div className="listado-convenios-cliente-container scroll-4">
          <table>
            <thead>
              <tr>
                <th>Razon Social</th>
                <th>
                  <div>Objeción</div>
                </th>
                <th>
                  <div>Saldo</div>
                </th>

                <th>
                  <div>Monto Convenio</div>
                </th>
                <th>
                  <div>Vencimiento Convenio</div>
                </th>
                <th>
                  <div>Responsable</div>
                </th>

                <th>
                  <div>Opciones</div>
                </th>
              </tr>
            </thead>
            <tbody>
              {convenios.map((vc) => (
                <tr>
                  <td>{vc.razon_social}</td>
                  <td>{vc.objecion}</td>
                  <td className="ta-right">{FormatMoney(vc.saldo)}</td>
                  <td className="ta-right">{FormatMoney(vc.monto)}</td>
                  <td className="ta-center">
                    {vc.fecha_convenio.split("T")[0]}
                  </td>
                  <td>{vc.nombreCompleto}</td>

                  <td>
                    <div className="convenio-pago-acciones-listado">
                      <div
                        className="boton-descargar-convenio-pago-pdf"
                        onClick={() => abrirModalDescarga(vc.folio)}
                      >
                        <CloudDownloadIcon /> Descargar{" "}
                      </div>
                      <div
                        className="boton-subir-evidencia-convenio-pago"
                        onClick={() => handleOpenModal(vc.folio)}
                      >
                        <CloudUploadIcon />
                        Cargar
                      </div>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <CargarConvenioModal
          open={openModal}
          handleCloseModal={handleCloseModal}
          folio={folio}
        />
        <DescargarConvenioModal
          open={modalDescarga}
          onClose={cerrarModalDescarga}
          folio={folio}
        />
      </div>
    </PlantillaScreen>
  );
};
